import PropTypes from 'prop-types';
import React from 'react';
import Button from '$partials/ui/button';
import IconArrowRight from '$partials/icons/icon-arrow-right';
import { formatLinkBlockToUrl } from '$utilities/format';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const StickyCTAButtons = ({
    cta1,
    cta2
}) => {

    // render
    return (
        <div className='w-full sm:w-auto sm:pr-[40px] md:pr-[60px] z-50 fixed right-0 bottom-0'>
            <div className='flex flex-row border border-black'>
                {cta1 && (
                    <Button
                        as='a'
                        className={`sticky-cta-button type-style-5 ${cta2 && ('border-r')} px-[20px] md:px-[40px] md:justify-center hover:icon-hover hover:text-white hover:bg-black`}
                        href={formatLinkBlockToUrl(cta1?.link)}
                        type='button'>
                        {cta1?.label}
                        <IconArrowRight />
                    </Button>
                )}
                {cta2 && (
                    <Button
                        as='a'
                        className={`${!cta1 && ('border-r')} md:px-[40px] px-[20px]  sticky-cta-button type-style-5 md:justify-center hover:icon-hover hover:text-white hover:bg-black`}
                        href={formatLinkBlockToUrl(cta2?.link)}>
                        {cta2?.label}
                        <IconArrowRight />
                    </Button>
                )}
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    cta1: PropTypes.object,
    cta2: PropTypes.object
};

StickyCTAButtons.propTypes = propTypes;

export default StickyCTAButtons;
